<template>
  <v-card
    class="card-height"
    color="var(--kaki)"
  >
    <div class="d-flex card-height flex-column pb-5 mx-6 pt-3">
      <div class="d-flex titre-h4 w-100 mb-auto text-start">
        "{{ temoignage.texteTemoignage }}"
      </div>
      <div class="d-flex flex-row mt-8 nom">
        <v-avatar
          v-if="temoignage.photo"
          rounded="lg"
          size="64"
        >
          <!-- on replace l'entête avant la partie chiffrée parce qu'elle seul est enregistrée dans le back -->
          <img
            :src="'data:image/jpeg;base64,'+temoignage.photo.contenu"
            alt="avatar"
          >
        </v-avatar>
        <v-icon
          v-else
          size="64"
        >
          mdi-account
        </v-icon>
        <div class="d-flex flex-column justify-center ml-3">
          <div class="d-flex titre-h4 secondary--text mb-1 text-start">
            {{ temoignage.prenomAdherent }} {{ temoignage.nomAdherent }}
          </div>
          <div class="d-flex flex-row">
            <v-icon small>
              mdi-map-marker
            </v-icon>
            <div class="texte texte-gris-fonce">
              {{ temoignage.lieuExploitation }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>

export default {
  name: 'Temoignage',
  props: {
    temoignage: {
      type: Object,
      required: true
    }
  },
}

</script>

<style lang="scss" scoped>
.card-height {
  height: 100%;
}

.avatar {
  height: 64px;
  width: 64px;
}

.nom {
  height: 70px;
}
</style>
